/*! @azure/msal-common v13.3.1 2023-10-27 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.3.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map



//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/@azure/msal-common/dist/packageMetadata.js
// module id = 396
// module chunks = 4